import { colors } from "../../../data/colors";
import { salesCodes } from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";

const deleteItemLine = ({
  docValues,
  modalData,
  countTotals,
  closeMsg,
}: stdObject) => {
  let tempData = docValues;
  if (salesCodes.filter((e: string) => e !== "COT").includes(docValues.type)) {
    tempData.commissions = tempData.commissions
      .filter(
        (e: stdObject) =>
          e.LINCOY !==
            tempData.items[modalData.index][`LIN${docValues.itemType}`] ||
          e.PAGCOY > 0,
      )
      .map((e: stdObject) => {
        if (e.LINCOY > modalData.index) {
          e.LINCOY = e.LINCOY - 1;
        }
        return e;
      });
  }

  const deletedLine = modalData.index + 1;
  let tempBatch: stdObject = {};

  Object.keys(tempData.batches).forEach((e) => {
    if (Number(e) < deletedLine) {
      tempBatch[e] = tempData.batches[e];
    } else if (Number(e) > deletedLine) {
      tempBatch[Number(e) - 1] = tempData.batches[e];
    }
  });
  tempData.batches = tempBatch;

  tempData.items.splice(modalData.index, 1);
  tempData.items = tempData.items.map((e: stdObject) => {
    if (e[`LIN${docValues.itemType}`] > modalData.index) {
      e[`LIN${docValues.itemType}`] = e[`LIN${docValues.itemType}`] - 1;
    }
    return e;
  });
  countTotals(tempData);
  closeMsg();
};

export const deleteItemModal = ({
  t,
  countTotals,
  docValues,
  modalData,
  closeMsg,
}: stdObject) => {
  return {
    title: t("p.wantToDeleteThisLine"),
    label:
      docValues.items && modalData.index in docValues.items
        ? docValues.items[modalData.index]["NOM" + docValues.itemType]
        : "",
    buttons: [
      {
        label: t("p.delete"),
        onClick: () =>
          deleteItemLine({ docValues, modalData, countTotals, closeMsg }),
        color: colors.red,
      },
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
